import axios from 'axios';
import { baseURL } from '../utility/Constants';

const SHUNT_METRICS_ENDPOINT = `${baseURL}/shunt-metrics`;

export const fetchShuntMetrics = async (emsName, timeFilter, date) => {
  try {
    const response = await axios.post(SHUNT_METRICS_ENDPOINT, {
      emsName,
      timeFilter,
      date
    });

    // Ensure all numeric values are properly converted
    const chartData = response.data.data.map(point => ({
      timestamp: Number(point.timestamp),
      shunt_current: Number(point.shunt_current),
      shunt_soc: Number(point.shunt_soc),
      ...(point.hour_timestamp && { hour_timestamp: Number(point.hour_timestamp) }),
      ...(point.data_points && { data_points: Number(point.data_points) })
    }));

    return {
      success: true,
      data: chartData,
      metadata: {
        emsName: response.data.emsName,
        timeFilter: response.data.timeFilter,
        startDate: response.data.startDate,
        endDate: response.data.endDate
      }
    };
  } catch (error) {
    console.error('Error fetching shunt metrics:', error);
    return {
      success: false,
      error: error.response?.data?.error || 'Failed to fetch shunt metrics',
      message: error.response?.data?.message || error.message
    };
  }
};

// Helper function to get current date in YYYY-MM-DD format
const formatDate = (date) => {
  return date.toISOString().split('T')[0];
};

// Convenience functions for common time filters
export const fetchDailyShuntMetrics = (emsName, date = new Date()) => {
  return fetchShuntMetrics(emsName, 'daily', formatDate(date));
};

export const fetchWeeklyShuntMetrics = (emsName, date = new Date()) => {
  return fetchShuntMetrics(emsName, 'weekly', formatDate(date));
};

export const fetchMonthlyShuntMetrics = (emsName, date = new Date()) => {
  return fetchShuntMetrics(emsName, 'monthly', formatDate(date));
};
